import React from "react";
import { useParams } from "react-router-dom";
import PDFViewer from "../components/PDFViewer";
import styled from "styled-components";

const Container = styled.div`
  padding: 24px;
  max-width: 900px;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: #333;
  text-align: center;
  margin-bottom: 24px;
`;

const Statement = () => {
  const { filename } = useParams();

  if (!filename) {
    return (
      <Container>
        <Title>Invalid Statement</Title>
        <p>No filename provided in URL.</p>
      </Container>
    );
  }

  const pdfUrl = `${window.location.origin}/statements/${filename}.pdf`;
  //const pdfUrl = `https://www.wallstreetmicrofinance.com/statements/${filename}.pdf`;

  return (
    <Container>
      <Title>Bank Statement</Title>
      <PDFViewer url={pdfUrl} />
    </Container>
  );
};

export default Statement;
